import { dataService } from '../../data';
import { AppConstants } from '@unpispas/upp-defs';

import { DataObject, ObjectOptions, RelatedObject } from "../base";
import { CreateObject } from "../item";
import { Place } from './place';
import { ExtraView, ExtraViewProxy } from '../views/extra';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { PlaceType } from '../types';
import { ExtraTableType } from '../types';
import { ExtraProductType } from '../types';
import { ExtraPeriodType } from '../types';
import { I18nValueType } from '../types';

const _schema = {
    "name": "EXTRA",
    "fields": [
        { name: "status", type: "string", default: "AC" },
        { name: "place", type: "objid" },
        { name: "name", type: "objid" },
        { name: "photo", type: "file" },
        { name: "description", type: "objid" },
        { name: "type", type: "string" },
        { name: "price", type: "number" },
        { name: "allday", type: "boolean" },
        { name: "allprd", type: "boolean" },
    ],
    relate: [
        { direction: ">", target: "PLACE", by: "place", name: "place", reason: "place", child: false, class: PlaceType },
        { direction: ">", target: "I18NVALUE", by: "name", name: "name", reason: "name", child: true, class: I18nValueType },
        { direction: ">", target: "I18NVALUE", by: "description", name: "description", reason: "description", child: true, class: I18nValueType },
        { direction: "<", target: "EXTRATABLE", by: "extra", name: "qrcode", reason: "qrcodes", child: true, class: ExtraTableType },
        { direction: "<", target: "EXTRAPRODUCT", by: "extra", name: "product", reason: "products", child: true, class: ExtraProductType },
        { direction: "<", target: "EXTRAPERIOD", by: "extra", name: "period", reason: "periods", child: true, class: ExtraPeriodType }
    ]
} as const;

const _ExtraClass = CreateObject(_schema);
if (!_ExtraClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class Extra extends _ExtraClass { 
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): Extra {
        return this._Copy(store) as Extra;
    }

    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || !this.Commited){
            return;
        }

        if (relation === 'place' && related instanceof Place){
            if (related === this.place){
                related.AddExtra(this);
            }
        }
    }

    override get viewProxy(): ExtraView {
        return ExtraViewProxy(this, this.data);
    }

    /****************************/
    /* CLASS MEMBERS            */
    /****************************/

    get avatar(): string | null {
        const _bg = 'd3c79b';
        const _fg = '000000';

        const _lb = this.name?.tr() ?? null;
        if (!_lb){
            return null;
        }

        return AppConstants.baseURL + 'photo/avatar?size=128&background=' + _bg + '&color=' + _fg + '&name=' + encodeURIComponent(_lb);
    }

    get photo(): string | null {
        return this['__base__photo'] || this.avatar;
    }

    set photo(value: string | null) {
        this['__base__photo'] = value;
    }

    get status(): string | null {
        return this['__base__status']
    }

    set status(value: string){
        if (this.status == 'DE'){
            return;     // cannot modify deleted items
        }

        if (this.status == value){
            return;
        }

        this['__base__status'] = value;
        if (this.place){
            if ((this.status == 'DE') && !this.Commited){
                this.place.DelExtra(this);
            }
            else {
                this.place.DoRefresh(this.table);
            }    
        }
    }

    /****************************/
    /* CUSTOM METHODS           */
    /****************************/

    get IsValid(): boolean {
        return (!!this.status && (this.status != 'DE'));
    }
}

